import type { UserSession } from '@/hooks/use-session/user-session.types';

type AgentsAccessInput = {
  user?: UserSession;
};

/**
 * Whether the current session has access to the Agents tab / API.
 * Returned by the backend on `GET /org/member` as `is_agents_enabled` so the predicate
 * (feature gate OR live mode OR firm employee) stays server-side.
 */
export const isAgentsTabAccessible = ({ user }: AgentsAccessInput): boolean => {
  return !!user?.isAgentsEnabled;
};
